// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"footer_innerWrapper__tunU5","wrapper":"footer_wrapper__jeZeL","social":"footer_social__ft_lA","ourLinks":"footer_ourLinks__smPBa","aboutUs":"footer_aboutUs__BaUOo"};